import type { MarkerItem } from 'tripPlanner/types/tripItem'
import { scrollToNewItemWithRetry } from 'tripPlanner/utils/scrollToNewItem'

export function scrollToItem(
  item: MarkerItem,
): void {
  if (!item.startDate) {
    window.scrollTo({ top: 250, behavior: 'smooth' })
    return
  }
  scrollToNewItemWithRetry(item.id)
}
